import { useEffect, useState } from "react";
import { Divider } from "@mui/material";

import apiClient from "../../lib/common/apiClient";
import parse from "html-react-parser";

function TkPopNoticeDisplay(props) {
    const { workOrderNumber, partNo, onSetContent, refreshToggle } = props;

    const [content, setContent] = useState("");

    useEffect(() => {
        if (workOrderNumber && partNo) {
            (async () => {
                apiClient
                    .get(`/api/TkPopNotice/${workOrderNumber}/${partNo}`)
                    .then((result) => {
                        setContent(result.data);

                        if (onSetContent) {
                            onSetContent(result.data);
                        }
                    })
                    .catch((reason) => {
                        setContent(null);

                        if (onSetContent) {
                            onSetContent(null);
                        }
                    });
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workOrderNumber, partNo, refreshToggle]);

    return (
        <>
            {content ? (
                <div className="ql-snow">
                    <div
                        className="ql-editor"
                        style={{
                            width: "100%",
                            height: "100%",
                            padding: "1% 1% 1% 1%",
                            fontSize: "30px",
                            overflow: "hidden",
                        }}
                    >
                        {parse(content.title)}
                    </div>
                    <Divider></Divider>
                    <div
                        className="ql-editor"
                        style={{
                            width: "100%",
                            height: "100%",
                            padding: "1% 1% 1% 1%",
                            fontSize: "20px",
                            overflow: "hidden",
                        }}
                    >
                        {parse(content.notice)}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}

export default TkPopNoticeDisplay;
